module.exports = __webpack_public_path__ + "static/nginr-news-e588e1e255be00daa73c8bf420615bf0.jpg";